import React from 'react';
import './preloader.css';
// import {Button, Modal, Form, FormGroup, ControlLabel, FormControl, Glyphicon} from 'react-bootstrap';

class Preloader extends React.Component {
    constructor(props) {
        super(props);
      }

      state = {

        }
      render () {
        return (
            <div>
            {/* <Modal.Dialog>
                <Modal.Body> */}
                    <div id="preloader">
                        <div id="loader"></div>
                    </div>
                {/* </Modal.Body>
            </Modal.Dialog> */}
            </div>
        )
    }
}

export default Preloader;


// WEBPACK FOOTER //
// ./src/components/preloader.js